type Footnote2 = {
    fontFamily: any;
    fontWeight: any;
    fontStyle: any;
    fontSize: any;
    letterSpacing: any;
    lineHeight: any;
};

export const footnote2: Footnote2 = {
    'fontFamily': 'var(--plasma-typo-footnote2-font-family, \'SB Sans Text\',sans-serif)',
    'fontWeight': 'var(--plasma-typo-footnote2-font-weight, 600)',
    'fontStyle': 'var(--plasma-typo-footnote2-font-style, normal)',
    'fontSize': 'var(--plasma-typo-footnote2-font-size, 0.875rem)',
    'letterSpacing': 'var(--plasma-typo-footnote2-letter-spacing, -0.0190em)',
    'lineHeight': 'var(--plasma-typo-footnote2-line-height, 1.125rem)'
};